export default {"src":"/_next/static/image/public/images/Greyarrow.1960140b4cd48f426193efccaabff01a.svg","height":24,"width":24};